import { Icon } from './icon';
import { cn } from '../lib/utils';

export function SubTitle({
  text,
  iconClass,
  href,
  className,
}: {
  text: string;
  iconClass?: string;
  href?: string;
  className?: string;
}) {
  if (href) {
    return (
      <h2 className={cn('font-serif text-xl font-medium', className)}>
        <a href={href} className="group flex w-fit items-center gap-3">
          {iconClass && <Icon className={`${iconClass} -mb-0.5 text-lg text-gray-400 duration-150`} />}
          <span className="underline decoration-gray-300 underline-offset-6 duration-100 group-hover:decoration-gray-400">
            {text}
          </span>
        </a>
      </h2>
    );
  }

  return (
    <h2 className={cn('group flex w-fit items-center gap-3 font-serif text-xl font-medium', className)}>
      {iconClass && <Icon className={`${iconClass} -mb-0.5 text-lg text-gray-400`} />}
      <span>{text}</span>
    </h2>
  );
}
